import { DialogComponent } from '@theme/dialog';

/**
 * Video dialog for APAP winner cards. Autoplays media on open and resets on close.
 *
 * @extends DialogComponent
 */
class ApapGanadoresVideoDialog extends DialogComponent {
  /** @type {string | null} */
  #originalIframeSrc = null;

  connectedCallback() {
    super.connectedCallback();

    const parentCloseDialog = this.closeDialog.bind(this);

    this.closeDialog = async () => {
      const iframe = this.querySelector('.apap-ganadores__video iframe');

      if (iframe instanceof HTMLIFrameElement && this.#originalIframeSrc) {
        iframe.src = this.#originalIframeSrc;
      }

      const video = this.querySelector('video');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      await parentCloseDialog();
    };
  }

  showDialog() {
    super.showDialog();

    const iframe = this.querySelector('.apap-ganadores__video iframe');

    if (iframe instanceof HTMLIFrameElement) {
      if (!this.#originalIframeSrc) {
        this.#originalIframeSrc = iframe.src;
      }

      try {
        const url = new URL(iframe.src);
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
      } catch {
        // Keep the original src if URL parsing fails.
      }
    }

    this.querySelector('video')?.play();
  }
}

if (!customElements.get('apap-ganadores-video-dialog')) {
  customElements.define('apap-ganadores-video-dialog', ApapGanadoresVideoDialog);
}
